// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSParagraph/index.less
// module id = 665
// module chunks = 42